import Reveal from "./Reveal";

export function parseTimeline(raw) {
  return raw
    .split("\n")
    .map((l) => l.trim())
    .filter(Boolean)
    .map((l) => {
      const [year = "", title = "", ...rest] = l.split("|").map((s) => s.trim());
      return { year, title, text: rest.join(" | ") };
    });
}

export default function StoryTimeline({ raw }) {
  const steps = parseTimeline(raw);
  if (steps.length === 0) return null;
  return (
    <section className="relative max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-24" data-testid="story-timeline">
      <Reveal className="text-center mb-14">
        <div className="smallcaps-label mb-3">Frise chronologique</div>
        <h2 className="font-display text-3xl md:text-4xl">Vingt ans, cinq étapes, une signature.</h2>
      </Reveal>

      <div className="relative">
        <div className="story-timeline-line" aria-hidden="true" />
        <ol className="relative grid gap-10 md:gap-6 md:grid-cols-5">
          {steps.map((s, i) => (
            <Reveal as="li" key={s.year + i} delay={i * 140} className="relative pl-12 md:pl-0 md:pt-14" data-testid={`story-timeline-step-${i}`}>
              <span className="story-node" aria-hidden="true" />
              <div className="font-display text-3xl md:text-4xl gold-text leading-none">{s.year}</div>
              <div className="smallcaps-label mt-3 mb-2" style={{ color: "#D99533", fontSize: "0.7rem" }}>{s.title}</div>
              <p className="text-sm text-muted-foreground leading-relaxed">{s.text}</p>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
}
